import { queryOptions } from "@tanstack/react-query";
import { apiGet } from "../helpers/request.helpers";
import { SchoolClass } from "../types/school.types";

export const groupQueryOptions = (id: number) =>
  queryOptions({
    queryKey: ["group", id],
    queryFn: () => fetchGroup(id),
  });

// export function useGroup(id: number) {
//   return useQuery(groupQueryOptions(id));
// }

const fetchGroup = async (id?: number) => {
  const data = await apiGet("/show-class", { class_id: id });
  if (
    data.Class.OrganizationID !==
    Number(localStorage.getItem("organization_id"))
  ) {
    //TODO: switch to org?
    throw Error(
      `Group does not belong to selected organization. Mismatching org id. Got ${
        data.Class.OrganizationID
      } but in localstorage it is ${Number(
        localStorage.getItem("organization_id")
      )}`
    );
  }
  const group: SchoolClass = data.Class;
  return group;
};
